import SurveyResults from '../components/SurveyResults';
import { Component } from 'react';
import { Chart } from 'chart.js';
import { Radar } from 'react-chartjs-2';

export function ResultsPage() {
  return (
    <SurveyResults />
  );
}